import React, { useEffect, useRef, useState } from 'react';
import './registry.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import { isMobile } from 'react-device-detect';
import * as ReactDOM from 'react-dom';
import {
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { loadRegistrySmevCheckList } from '../actions';
import { getSystemData } from '../../System/reducer';
import { getRegisterData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import { dateTimeFormatter, localeFormatter, statusFormatter } from '../../../utils/formatters';
import {
  APPLICATION_SUBJECT_TYPES,
  CHECK_STATUS_NAMES,
  SUBJECT_TYPE,
} from '../../../configs';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import MobileApplicationHistoryFooter from '../../Application/components/MobileApplicationHistoryFooter';
import RowFilterForm from '../../FilterTemplate/components/RowFilterForm';
import PropertyGrid from '../../../components/base/Grid/PropertyGrid';

export default function RegistrySmevCheckPage() {
  const blockRef = useRef(null);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingRegistrySmevCheckList,
    registrySmevCheckList = [],
    registrySmevCheckListMeta = {},
    loadingRegistryHistory,
  } = useSelector(getRegisterData);
  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const {
    reset, getValues, control, setValue, watch,
  } = useForm({ defaultValues: getJsonFromStorage('registry-SmevCheck-filter', defaultFilterValues) });

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].registrySmevCheckListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadRegistrySmevCheckList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);

  const columns = [
    {
      dataField: 'type',
      text: 'Запрашиваемая информация',
      formatter: e => e && e.name,
    },
    {
      dataField: 'id',
      text: 'Идентификатор обращения',
    },
    {
      dataField: 'subject',
      text: 'Субъект',
      headerClassName: 'subject-column',
      formatter: (_, item) => {
        const { subject_type, subject_id } = item;
        return (
          <>
            {APPLICATION_SUBJECT_TYPES.includes(subject_type) ? <NavLink to={`/application?application_id=${subject_id}`}>{localeFormatter('subject.type', subject_type)}</NavLink> : null}
            {subject_type === SUBJECT_TYPE.CARRIER ? <NavLink to={`/region-registry-carrier?registry_id=${subject_id}`}>{localeFormatter('subject.type', subject_type)}</NavLink> : null}
            {subject_type === SUBJECT_TYPE.ORDER_SERVICE ? <NavLink to={`/region-registry/szlt?registry_id=${subject_id}`}>{localeFormatter('subject.type', subject_type)}</NavLink> : null}
            {subject_type === SUBJECT_TYPE.VEHICLE ? <NavLink to={`/region-registry/passenger-taxi?registry_id=${subject_id}`}>{localeFormatter('subject.type', subject_type)}</NavLink> : null}
          </>
        );
      },
    },
    {
      dataField: 'created_at',
      text: 'Дата запроса',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'responded_at',
      text: 'Дата получения ответа',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'status',
      text: 'Статус запроса',
      formatter: a => statusFormatter(a, 'check.status', CHECK_STATUS_NAMES),
    },
  ];

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const renderFooter = () => {
    const element = document.getElementById('app-content-footer');
    if (!element) {
      return null;
    }
    return ReactDOM.createPortal(<MobileApplicationHistoryFooter
      control={control}
      defaultFilterValues={defaultFilterValues}
      getValues={getValues}
      reset={reset}
      page={PAGE_TYPE.REGISTRY_SMEV_CHECK}
    />, element);
  };

  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingRegistrySmevCheckList || loadingRegistryHistory} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.region.registry.smev.check' })}</div>
        {!isMobile ? (
          <FilterRow>
            <RowFilterForm
              control={control}
              getValues={getValues}
              defaultValues={{}}
              page={PAGE_TYPE.REGISTRY_SMEV_CHECK}
            />
          </FilterRow>
        ) : null}
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          {!isMobile ? (
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <CustomizedGrid
                  rowClassFormatter={item => 'clickable-table-row'}
                  data={registrySmevCheckList}
                  columns={columns}
                  changeSort={changeSort}
                  sort={sort}
                  // onClickByRow={item => window.open(`/application?application_id=${item.number}`, '_blank').focus()}
                  name="registry-smev-check-list"
                />
              </div>
            </div>
          ) : (
            <PropertyGrid
              rowClassFormatter={item => 'clickable-table-row'}
              data={registrySmevCheckList}
              columns={columns}
              changeSort={changeSort}
              sort={sort}
            // onClickByRow={item => window.open(`/application?application_id=${item.number}`, '_blank').focus()}
              name="registry-smev-check-list"
            />
          )}
          <Pagination meta={registrySmevCheckListMeta} list={registrySmevCheckList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isMobile ? renderFooter() : null}
    </div>
  );
}
